@if (isModalActive) {
  <div class="modal-header">
    <h3 class="modal-title fkm-modal-title" id="modal-title">Redigera</h3>
    <button type="button" class="btn-close" (click)="dismiss()"></button>
  </div>
}
<div [className]="isModalActive ? 'content fkm-modal-active' : 'content'">
  <rask-container-block>
    <rask-header size="3" underline>
      {{title}}
      <rask-action-button
        (click)="addMall()"
        [disabled]="!isAllowedToAddRows() || !canEdit()"
        icon="fas fa-plus">
      {{texts.nyMall}}</rask-action-button>
    </rask-header>
    <div class="produktionsmallar-list">
      <div class="row pt-3">
        <div class="col ps-4">
          <label>Namn</label>
        </div>
        <div class="col-4">
          <label>Senast ändrad</label>
        </div>
        @if (isCKMall) {
          <div class="col-4">
            <label>Uppdragsgivare</label>
          </div>
        }
      </div>
      @for (mall of mallar; track mall) {
        <rask-produktionsmall-accordion #accordion
          [headerText]="mall.benamning"
          [isDefaultExpanded]="isMallDefaultExpanded(mall)">
          <ng-container headerContent>
            <div class="col-4">{{mall.uDate | date: 'shortDate'}}@if (getDirtyStatus(mall.guid)) {
              <span
              > *</span>
            }
          </div>
          @if (isCKMall) {
            <div class="col-4">{{mall.ckLeverantorNamn}}</div>
          }
        </ng-container>
        @if (!accordion.isCollapsed || getDirtyStatus(mall.guid)) {
          <rask-produktionsmall-accordion-body #mallbodys
            [canEdit]="canEdit()"
            [mall]="mall"
            [isCKMall]="isCKMall"
            (refreshRequest)="refresh($event)">
          </rask-produktionsmall-accordion-body>
        }
      </rask-produktionsmall-accordion>
    }
  </div>
  <ng-container footer>
  </ng-container>
</rask-container-block>
</div>